import { useMsal } from '@azure/msal-react'
import ReactGA4 from 'react-ga4'

import { localStorageConstants } from 'constants/localstorageConstants'
import { useAppContext } from 'providers/AppProviders'
import { getFromStorage } from 'services/helper'

const useGoogleAnalytics = () => {
  const { accounts } = useMsal()
  const { userAccessMapping = [] } = useAppContext()
  const loginDetail = accounts?.[0]
  const userName = loginDetail?.name ?? ''
  const userData = {
    user_name: userName,
    role: (loginDetail?.idTokenClaims?.role as string) || '',
    supplier_consumer_viewed:
      getFromStorage(localStorageConstants?.CUSTOMER_FILTER)?.[0]?.slug || userAccessMapping?.[0]?.SupplierName || '',
  }
  const initializeGoogleAnalytics = () => {
    // Initialize GA4 - Add Measurement ID
    const MEASUREMENT_ID = process.env?.REACT_APP_MEASUREMENT_ID ?? ''
    const userId = (loginDetail?.idTokenClaims?.userId as number) || ''
    ReactGA4.initialize(MEASUREMENT_ID)
    if (userId) {
      ReactGA4.set({ userId: `${userId} - ${userName}` })
    }
  }

  const trackPageView = (page: string, title: string) => {
    ReactGA4.send({ hitType: 'pageview', page, title, ...userData })
  }

  const trackGoogleAnalyticsEvent = (category: string, event_name: string, data?: object, label?: string) => {
    const event_params = {
      category,
      label,
      ...userData,
      ...data,
    }
    // Send GA4 Event
    ReactGA4.event(event_name, event_params)
  }

  return { initializeGoogleAnalytics, trackPageView, trackGoogleAnalyticsEvent }
}

export default useGoogleAnalytics
